{
  "payroll.title": "Payroll",
  "payroll.month.title": "Payroll · {month}",
  "payroll.month.subtitle": "Priced live while it’s a draft, stored for good once locked.",
  "payroll.month.pick": "Payroll month",
  "payroll.month.previous": "Previous month",
  "payroll.month.next": "Next month",
  "payroll.month.loadError": "We couldn’t load this month",
  "payroll.tabs.label": "Payroll month views",
  "payroll.tabs.sheet": "Sheet",
  "payroll.tabs.summary": "CEO summary",
  "payroll.tabs.entries": "Entries",
  "payroll.tabs.advances": "Advances",
  "payroll.tabs.claims": "Expense claims",
  "payroll.status.draft": "Draft",
  "payroll.status.final": "Final",
  "payroll.status.locked": "Locked",
  "payroll.value.none": "Not set",
  "payroll.filter.all": "All",
  "payroll.step.label": "Month progress",
  "payroll.step.draft": "Draft",
  "payroll.step.final": "Final",
  "payroll.step.locked": "Locked",
  "payroll.step.paid": "Paid",
  "payroll.step.done": "(done)",
  "payroll.step.draftCaption": "Priced live",
  "payroll.step.paidCaption": "{done} of {total} paid",
  "payroll.step.payDate": "Pay date {date}",
  "payroll.actions.finalize": "Finalize payroll",
  "payroll.actions.reopen": "Reopen",
  "payroll.actions.lock": "Lock month",
  "payroll.actions.correct": "Record a correction",
  "payroll.actions.bankFile": "Bank file (CSV)",
  "payroll.actions.blocked": "{count, plural, one {Clear the # item under review to finalize.} other {Clear the # items under review to finalize.}}",
  "payroll.finalize.title": "Finalize {month}?",
  "payroll.finalize.body": "The month is set for payment on the first day of the next month, and no new entries can be added for it. You can reopen it until it’s locked.",
  "payroll.finalize.confirm": "Finalize month",
  "payroll.finalize.pending": "Finalizing…",
  "payroll.finalize.done": "{month} is final.",
  "payroll.reopen.title": "Reopen {month}?",
  "payroll.reopen.body": "The month goes back to draft: entries can be added again, and its numbers are priced live.",
  "payroll.reopen.confirm": "Reopen",
  "payroll.reopen.pending": "Reopening…",
  "payroll.reopen.done": "{month} is a draft again.",
  "payroll.lock.title": "Lock {month}?",
  "payroll.lock.description": "Locking is for good. It stores the month as it stands:",
  "payroll.lock.storesPayslips": "Every payslip is stored with its lines and inputs.",
  "payroll.lock.locksAttendance": "The month’s attendance is locked too.",
  "payroll.lock.settlesEntries": "Installments are marked deducted and open corrections settled.",
  "payroll.lock.correctionsAfter": "After this, any change is a correction settled in a later month.",
  "payroll.lock.typeLabel": "Type {month} to confirm",
  "payroll.lock.typeHint": "Type it exactly, as year-month.",
  "payroll.lock.confirm": "Lock month",
  "payroll.lock.locking": "Locking…",
  "payroll.lock.done": "{month} is locked.",
  "payroll.locked.title": "This month is locked",
  "payroll.locked.body": "Its payslips are stored for good. To change anything, record a correction; the next month locked settles it.",
  "payroll.blockers.title": "{count, plural, one {# item to review before finalizing} other {# items to review before finalizing}}",
  "payroll.blockers.people": "{count, plural, one {· # person} other {· # people}}",
  "payroll.blockers.showNames": "Show names",
  "payroll.blockers.recheck": "Check again",
  "payroll.blocker.attendance_not_final": "Attendance isn’t final",
  "payroll.blocker.missing_hire_date": "No hire date",
  "payroll.blocker.missing_salary": "No salary",
  "payroll.blocker.dates_inconsistent": "Employment dates don’t add up",
  "payroll.blocker.attendance_review": "Attendance needs review",
  "payroll.blocker.pending_requests": "Requests waiting for a decision",
  "payroll.blocker.pending_adjustments": "Entries waiting for approval",
  "payroll.blocker.overtime_basis_missing": "No OT basis for overtime",
  "payroll.blocker.settlement_pending": "Final settlement not confirmed",
  "payroll.blocker.negative_net": "Net below zero",
  "payroll.blockerHint.attendance_not_final": "This month’s attendance must be finalized before payroll.",
  "payroll.blockerHint.missing_hire_date": "Add the hire date to the person’s record.",
  "payroll.blockerHint.missing_salary": "Add a salary on the person’s Pay tab.",
  "payroll.blockerHint.dates_inconsistent": "The last working day falls before the hire date. Fix the record.",
  "payroll.blockerHint.attendance_review": "Missing punches or days to judge; decide them in attendance.",
  "payroll.blockerHint.pending_requests": "Leave or attendance requests in this month still wait for a decision.",
  "payroll.blockerHint.pending_adjustments": "Approve or reject them; they don’t count until then.",
  "payroll.blockerHint.overtime_basis_missing": "Overtime was approved but there is no salary to price it. Add the salary (or overtime basis) on the person's Pay tab.",
  "payroll.blockerHint.settlement_pending": "Confirm the leaver’s leave days on their Pay tab.",
  "payroll.blockerHint.negative_net": "Deductions exceed pay. Open the payslip and check its lines.",
  "payroll.blockerAction.attendance": "Review attendance",
  "payroll.blockerAction.requests": "Open requests",
  "payroll.blockerAction.entries": "Review entries",
  "payroll.table.caption": "Payroll sheet",
  "payroll.table.currency": "Amounts in {code}",
  "payroll.table.open": "Open {name}’s payslip",
  "payroll.table.actions": "Actions",
  "payroll.table.empty.title": "Nobody to pay",
  "payroll.table.empty.body": "Nobody with an HR record is employed in this month.",
  "payroll.column.code": "Code",
  "payroll.column.name": "Name",
  "payroll.column.employee": "Employee",
  "payroll.column.salary": "Salary",
  "payroll.column.payableDays": "Paid days",
  "payroll.column.basic": "Basic",
  "payroll.column.deductionDays": "Deduction days",
  "payroll.column.attendance": "Attendance",
  "payroll.column.overtime": "Overtime",
  "payroll.column.additions": "Additions",
  "payroll.column.deductions": "Other deductions & installments",
  "payroll.column.net": "Net",
  "payroll.column.netWithCurrency": "Net (EGP)",
  "payroll.column.change": "Δ last month",
  "payroll.column.paid": "Paid",
  "payroll.column.total": "Total",
  "payroll.change.none": "No locked month before to compare with",
  "payroll.change.previous": "Last month’s net: {amount}",
  "payroll.change.large": "Changed more than {percent} from last month",
  "payroll.paid.yes": "Paid",
  "payroll.paid.no": "Not paid",
  "payroll.paid.toggle": "Paid: {name}",
  "payroll.paid.markedPaid": "{name}’s pay is marked paid.",
  "payroll.paid.markedUnpaid": "{name}’s pay is marked unpaid.",
  "payroll.payslip.title": "Payslip",
  "payroll.payslip.label": "{name}’s payslip",
  "payroll.payslip.loadError": "We couldn’t load this payslip",
  "payroll.payslip.blocked": "Under review",
  "payroll.payslip.linesCaption": "Payslip lines",
  "payroll.payslip.item": "Item",
  "payroll.payslip.amount": "Amount",
  "payroll.payslip.net": "Net",
  "payroll.facts.salary": "Salary",
  "payroll.facts.overtimeBasis": "OT basis",
  "payroll.facts.sameAsSalary": "Same as salary",
  "payroll.facts.dayBasis": "Day basis",
  "payroll.facts.dailyHours": "Daily hours",
  "payroll.facts.payableDays": "Payable days",
  "payroll.facts.deductionDays": "Deduction days",
  "payroll.facts.days": "{count, plural, one {# day} other {# days}}",
  "payroll.line.basic": "Basic salary",
  "payroll.line.attendance": "Attendance deduction",
  "payroll.line.overtime_day": "Overtime (day)",
  "payroll.line.overtime_night": "Overtime (night)",
  "payroll.line.rest_day_work": "Rest-day work",
  "payroll.line.holiday_work": "Public holiday work",
  "payroll.line.bonus": "Bonus",
  "payroll.line.allowance": "Allowance",
  "payroll.line.reimbursement": "Reimbursement",
  "payroll.line.deduction": "Deduction",
  "payroll.line.advance": "Advance installment",
  "payroll.line.correction": "Correction",
  "payroll.line.leave_encashment": "Leave encashment",
  "payroll.line.reduced_pay_leave": "Leave at reduced pay",
  "payroll.line.unpaid_permission": "Unpaid permission time",
  "payroll.formula.legend.basic": "Salary ÷ day basis × payable days",
  "payroll.formula.legend.attendance": "Salary ÷ day basis × deduction days",
  "payroll.formula.legend.encashment": "Last salary ÷ day basis × leave days paid",
  "payroll.formula.legend.wageDays": "OT basis ÷ day basis × days",
  "payroll.formula.legend.hourly": "OT basis ÷ day basis ÷ daily hours × rate × hours",
  "payroll.formula.legend.unit": "Quantity × unit value",
  "payroll.formula.legend.reducedPay": "Unpaid share of the leave days × the day's value",
  "payroll.formula.legend.permission": "Hours × the hourly value of the day",
  "payroll.formula.legend.rounded": "Quantity × unit value rounded for display; the amount itself is exact.",
  "payroll.source.entry": "Open the entry",
  "payroll.source.advance": "Open the advance",
  "payroll.source.overtime": "Open overtime",
  "payroll.source.attendance": "Open attendance",
  "payroll.source.salary": "Open salary history",
  "payroll.source.settlement": "Open the final settlement",
  "payroll.summary.agency": "404 Creative",
  "payroll.summary.title": "Payroll summary · {month}",
  "payroll.summary.caption": "Net pay for {month}",
  "payroll.summary.payDate": "Pay date: {date}",
  "payroll.summary.payDateLater": "The pay date is set when the month is finalized.",
  "payroll.summary.underReview": "Under review",
  "payroll.summary.totalHidden": "Hidden: {count, plural, one {# item} other {# items}} under review",
  "payroll.summary.reviewNotice": "{count, plural, one {# item is under review; that person's net and the total stay hidden until you settle it.} other {# items are under review; those nets and the total stay hidden until you settle them.}}",
  "payroll.summary.paidCount": "{done} of {total} payslips paid",
  "payroll.summary.paidLater": "Paid switches appear once the month is locked.",
  "payroll.summary.print": "Print",
  "payroll.summary.preparedBy": "Prepared by",
  "payroll.summary.approvedBy": "Approved by",
  "payroll.adjustments.title": "Additions and deductions",
  "payroll.adjustments.description": "Bonuses, allowances, reimbursements and deductions entered by hand for this month.",
  "payroll.adjustments.closed": "This month is no longer a draft, so its entries can’t change. Reopen it, or record a correction once it’s locked.",
  "payroll.adjustments.filter": "Filter entries by status",
  "payroll.adjustments.loadError": "We couldn’t load this month’s entries.",
  "payroll.adjustments.empty.title": "No entries yet",
  "payroll.adjustments.empty.body": "Bonuses, allowances and deductions for this month will show here.",
  "payroll.adjustment.title": "New entry",
  "payroll.adjustment.description": "It counts in this month once someone approves it.",
  "payroll.adjustment.add": "Add entry",
  "payroll.adjustment.submit": "Add entry",
  "payroll.adjustment.added": "Entry added. It counts once it’s approved.",
  "payroll.adjustment.kind": "Kind",
  "payroll.adjustment.kind.bonus": "Bonus",
  "payroll.adjustment.kind.allowance": "Allowance",
  "payroll.adjustment.kind.reimbursement": "Reimbursement",
  "payroll.adjustment.kind.deduction": "Deduction",
  "payroll.adjustment.adds": "Adds to the net",
  "payroll.adjustment.subtracts": "Taken from the net",
  "payroll.adjustment.date": "Counts on",
  "payroll.adjustment.statusLabel": "Status",
  "payroll.adjustment.status.pending": "Waiting for approval",
  "payroll.adjustment.status.approved": "Approved",
  "payroll.adjustment.status.rejected": "Rejected",
  "payroll.adjustment.addedBy": "Added by {name} · {when}",
  "payroll.adjustment.decidedBy": "Decided by {name} · {when}",
  "payroll.adjustment.approve": "Approve",
  "payroll.adjustment.approveFor": "Approve {name}’s entry",
  "payroll.adjustment.approved": "Entry approved.",
  "payroll.adjustment.reject": "Reject",
  "payroll.adjustment.rejectFor": "Reject {name}’s entry",
  "payroll.adjustment.rejectTitle": "Reject {name}’s entry?",
  "payroll.adjustment.rejectBody": "The entry stays on record as rejected and is not paid.",
  "payroll.adjustment.rejected": "Entry rejected.",
  "payroll.adjustment.remove": "Remove",
  "payroll.adjustment.removeFor": "Remove {name}’s entry",
  "payroll.adjustment.removeTitle": "Remove {name}’s entry?",
  "payroll.adjustment.removeBody": "Nobody has decided on it yet, so removing it leaves pay untouched.",
  "payroll.adjustment.removed": "Entry removed.",
  "payroll.corrections.title": "Corrections",
  "payroll.corrections.description": "A locked month never changes. Money owed or overpaid is recorded as a correction, settled in the next month locked, where it shows as a line on the payslip.",
  "payroll.correction.title": "Correct a locked month",
  "payroll.correction.description": "Money owed or overpaid for a locked month. It is paid or recovered in the next month locked.",
  "payroll.correction.month": "Locked month",
  "payroll.correction.noLocked": "No month has been locked yet, so there is nothing to correct.",
  "payroll.correction.direction": "Direction",
  "payroll.correction.owed": "Owed to them",
  "payroll.correction.owedHint": "Paid with the next salary.",
  "payroll.correction.overpaid": "Overpaid",
  "payroll.correction.overpaidHint": "Recovered from the next salary.",
  "payroll.correction.submit": "Record correction",
  "payroll.correction.recorded": "Correction recorded. The next month locked settles it.",
  "payroll.form.person": "Person",
  "payroll.form.personPlaceholder": "Choose a person",
  "payroll.form.personSearch": "Search by name or code",
  "payroll.form.personEmpty": "Nobody matches.",
  "payroll.form.amount": "Amount (EGP)",
  "payroll.form.reason": "Reason",
  "payroll.form.saving": "Saving…",
  "payroll.form.errors.amount": "Type an amount above zero, with up to two decimals.",
  "payroll.form.errors.reason": "Write a reason of at least 3 letters.",
  "payroll.form.errors.tooLong": "This is too long.",
  "payroll.form.errors.date": "Pick a date.",
  "payroll.form.errors.person": "Pick a person.",
  "payroll.form.errors.month": "Pick a locked month.",
  "payroll.advances.title": "Advances",
  "payroll.advances.description": "Advances on salary and the installments that recover them.",
  "payroll.advances.filter": "Filter advances by status",
  "payroll.advances.loadError": "We couldn’t load the advances.",
  "payroll.advances.empty.title": "No advances",
  "payroll.advances.empty.body": "Advances on salary and their installments will show here.",
  "payroll.advances.emptyFilter": "No advances with this status",
  "payroll.advance.add": "New advance",
  "payroll.advance.title": "New advance",
  "payroll.advance.description": "Paid ahead of salary and recovered in monthly installments.",
  "payroll.advance.total": "Total (EGP)",
  "payroll.advance.installments": "Installments",
  "payroll.advance.firstMonth": "First installment",
  "payroll.advance.preview": "Installment plan",
  "payroll.advance.previewEmpty": "Type the total and the number of installments to see the plan.",
  "payroll.advance.installmentNumber": "Installment {number}",
  "payroll.advance.errors.installments": "Use a whole number from 1 to 36.",
  "payroll.advance.submit": "Record advance",
  "payroll.advance.added": "Advance recorded.",
  "payroll.advance.remainingOf": "{amount} left of {total}",
  "payroll.advance.status.active": "Active",
  "payroll.advance.status.settled": "Settled",
  "payroll.advance.status.cancelled": "Cancelled",
  "payroll.advance.cancel": "Cancel advance",
  "payroll.advance.cancelTitle": "Cancel this advance?",
  "payroll.advance.cancelBody": "The installments still scheduled ({amount}) are waived and won’t be deducted.",
  "payroll.advance.cancelled": "Advance cancelled.",
  "payroll.installment.status.scheduled": "Scheduled",
  "payroll.installment.status.deducted": "Deducted",
  "payroll.installment.status.postponed": "Postponed",
  "payroll.installment.status.waived": "Waived",
  "payroll.installment.postpone": "Postpone",
  "payroll.installment.postponeMonth": "Postpone the {month} installment",
  "payroll.installment.postponeTitle": "Postpone the {month} installment?",
  "payroll.installment.postponeBody": "It moves after the last installment; the reason is kept with it.",
  "payroll.installment.postponed": "{month} installment postponed.",
  "payroll.claims.title": "Expense claims",
  "payroll.claims.description": "Managers and HR decide claims in Requests; approved ones are paid back in the next open month.",
  "payroll.claims.decide": "Decide in Requests",
  "payroll.claims.filter": "Filter claims by status",
  "payroll.claims.loadError": "We couldn’t load the expense claims.",
  "payroll.claims.empty.title": "No expense claims",
  "payroll.claims.empty.body": "Claims with this status will show here.",
  "payroll.claim.new": "New expense claim",
  "payroll.claim.newTitle": "New expense claim",
  "payroll.claim.newDescription": "Your manager, then HR, decide; once approved, it’s added to your next salary.",
  "payroll.claim.spentOn": "Date spent",
  "payroll.claim.category": "Category",
  "payroll.claim.categoryHint": "Pick one or type your own.",
  "payroll.claim.description": "What it was for",
  "payroll.claim.receipt": "Receipt",
  "payroll.claim.receiptHint": "A PDF or a photo, up to 10 MB.",
  "payroll.claim.noReceipt": "No receipt",
  "payroll.claim.openReceipt": "Open receipt {name}",
  "payroll.claim.attachReceipt": "Attach receipt",
  "payroll.claim.replaceReceipt": "Replace receipt",
  "payroll.claim.receiptAttached": "Receipt attached.",
  "payroll.claim.submit": "Send claim",
  "payroll.claim.sent": "Claim sent for approval.",
  "payroll.claim.sentWithoutReceipt": "Claim sent, but the receipt didn’t upload. Attach it from the list.",
  "payroll.claim.withdraw": "Withdraw",
  "payroll.claim.withdrawTitle": "Withdraw this claim?",
  "payroll.claim.withdrawBody": "Nobody will be asked to decide it any more.",
  "payroll.claim.withdrawn": "Claim withdrawn.",
  "payroll.claim.statusLabel": "Status",
  "payroll.claim.status.pending": "Waiting for a decision",
  "payroll.claim.status.approved": "Approved",
  "payroll.claim.status.rejected": "Rejected",
  "payroll.claim.status.cancelled": "Withdrawn",
  "payroll.claim.errors.category": "Write a category of at least 2 letters.",
  "payroll.claim.errors.description": "Say what it was for, in a few words.",
  "payroll.claim.errors.receiptType": "Attach a PDF, PNG, JPEG or WebP.",
  "payroll.claim.errors.receiptSize": "The receipt is larger than 10 MB.",
  "payroll.claim.categories.transport": "Transport",
  "payroll.claim.categories.meals": "Meals",
  "payroll.claim.categories.supplies": "Supplies",
  "payroll.claim.categories.software": "Software",
  "payroll.claim.categories.travel": "Travel",
  "payroll.claim.categories.other": "Other",
  "payroll.flow.step": "{role}: {status}",
  "payroll.flow.manager": "Manager",
  "payroll.flow.hr": "HR",
  "payroll.flow.waiting": "waiting",
  "payroll.flow.current": "deciding",
  "payroll.flow.approved": "approved",
  "payroll.flow.rejected": "rejected",
  "payroll.flow.skipped": "skipped",
  "payroll.pay.title": "Pay",
  "payroll.pay.description": "Salary, where it’s paid, advances and the final settlement.",
  "payroll.compensation.title": "Salary",
  "payroll.compensation.description": "The net monthly salary from each date, and the wage overtime is priced on.",
  "payroll.compensation.add": "New salary",
  "payroll.compensation.addTitle": "New salary",
  "payroll.compensation.addDescription": "{name}’s salary from a date. A version from the same date replaces it.",
  "payroll.compensation.from": "Effective from",
  "payroll.compensation.fromHint": "The first day the salary applies.",
  "payroll.compensation.fromDate": "From {date}",
  "payroll.compensation.net": "Net monthly (EGP)",
  "payroll.compensation.overtimeBasis": "OT basis (EGP)",
  "payroll.compensation.overtimeBasisHint": "Leave empty to price overtime on the net salary.",
  "payroll.compensation.basisValue": "OT basis {amount}",
  "payroll.compensation.basisSame": "Overtime on the net salary",
  "payroll.compensation.reason": "Reason (optional)",
  "payroll.compensation.submit": "Save salary",
  "payroll.compensation.saved": "Salary saved.",
  "payroll.compensation.current": "Current",
  "payroll.compensation.upcoming": "Upcoming",
  "payroll.compensation.loadError": "We couldn’t load the salary history.",
  "payroll.compensation.empty.title": "No salary yet",
  "payroll.compensation.empty.body": "Add {name}’s salary so payroll can price their month.",
  "payroll.payment.title": "Payment details",
  "payroll.payment.description": "Where this person’s pay goes.",
  "payroll.payment.method": "Method",
  "payroll.payment.bank": "Bank",
  "payroll.payment.account": "Account",
  "payroll.payment.accountHint": "IBAN, account number, wallet or InstaPay address. Stored sealed; only the last four show.",
  "payroll.payment.notes": "Notes",
  "payroll.payment.reveal": "Reveal",
  "payroll.payment.hide": "Hide",
  "payroll.payment.add": "Add",
  "payroll.payment.edit": "Edit",
  "payroll.payment.addTitle": "Payment details",
  "payroll.payment.editTitle": "Edit payment details",
  "payroll.payment.editDescription": "Where {name}’s pay goes.",
  "payroll.payment.editAudited": "Saving replaces the account on file, so it is shown here in full; this reading is recorded.",
  "payroll.payment.auditNotice": "Revealing or editing the account shows it in full, and each reading is recorded in the activity log. It masks again after {seconds} seconds.",
  "payroll.payment.revealError": "We couldn’t read the account to edit it.",
  "payroll.payment.loadError": "We couldn’t load the payment details.",
  "payroll.payment.submit": "Save details",
  "payroll.payment.saved": "Payment details saved.",
  "payroll.payment.methods.bank_transfer": "Bank transfer",
  "payroll.payment.methods.instapay": "InstaPay",
  "payroll.payment.methods.wallet": "Mobile wallet",
  "payroll.payment.methods.cash": "Cash",
  "payroll.payment.methods.other": "Other",
  "payroll.settlement.title": "Final settlement",
  "payroll.settlement.description": "The leaver’s last month: unused leave paid out, advances recovered, assets handed back.",
  "payroll.settlement.loadError": "We couldn’t load the final settlement.",
  "payroll.settlement.notDue.title": "No final settlement",
  "payroll.settlement.notDue.body": "There’s no last working day on the record. Once HR records one, the final settlement appears here.",
  "payroll.settlement.state.unconfirmed": "Not confirmed",
  "payroll.settlement.state.confirmed": "Confirmed",
  "payroll.settlement.state.stale": "Confirm again",
  "payroll.settlement.staleTitle": "The last working day changed",
  "payroll.settlement.staleBody": "It changed after the settlement was confirmed. Check the days and confirm again.",
  "payroll.settlement.unconfirmedBody": "The month can’t be finalized until the leave days are confirmed.",
  "payroll.settlement.confirmedBy": "Confirmed by {name} · {when}",
  "payroll.settlement.lastDay": "Last working day",
  "payroll.settlement.month": "Settled in",
  "payroll.settlement.suggested": "Leave due",
  "payroll.settlement.daysValue": "{days} days",
  "payroll.settlement.dayValue": "Day value",
  "payroll.settlement.early": "Installments recovered early",
  "payroll.settlement.leaveCaption": "Leave due on exit",
  "payroll.settlement.kind": "Leave",
  "payroll.settlement.allowance": "This year",
  "payroll.settlement.earned": "Earned",
  "payroll.settlement.credits": "Credits",
  "payroll.settlement.used": "Used",
  "payroll.settlement.due": "Due",
  "payroll.settlement.totalDue": "Total due",
  "payroll.settlement.earnedExplained": "Earned is this year’s allowance by calendar days employed up to the last day. Due = earned + credits − used.",
  "payroll.settlement.assetsTitle": "{count, plural, one {# item not handed back} other {# items not handed back}}",
  "payroll.settlement.assetSince": "since {date}",
  "payroll.settlement.daysToPay": "Leave days to pay",
  "payroll.settlement.daysHint": "Leave due: {days} days.",
  "payroll.settlement.reasonRequired": "Reason",
  "payroll.settlement.reasonOptional": "Reason (optional)",
  "payroll.settlement.reasonHint": "Needed: the days differ from the leave due.",
  "payroll.settlement.errors.days": "Type the days, from 0 to 365, with up to two decimals.",
  "payroll.settlement.errors.reason": "Say why the days paid differ from the leave due.",
  "payroll.settlement.confirm": "Confirm settlement",
  "payroll.settlement.confirmAgain": "Confirm again",
  "payroll.settlement.confirming": "Confirming…",
  "payroll.settlement.confirmed": "Final settlement confirmed.",
  "payroll.settlement.monthClosed": "The month is {status}. Reopen it to change the settlement.",
  "payroll.settlement.remove": "Remove settlement",
  "payroll.settlement.removeTitle": "Remove the final settlement?",
  "payroll.settlement.removeBody": "The leave days are no longer paid, and the month waits for a new confirmation.",
  "payroll.settlement.removed": "Final settlement removed.",
  "payroll.settlement.preview": "Last month’s payslip",
  "payroll.settlement.previewHint": "Priced as it stands, with the leave days confirmed.",
  "payroll.me.payslips": "My payslips",
  "payroll.me.payslipsHint": "One for each locked month, with every line.",
  "payroll.me.payslipsError": "We couldn’t load your payslips.",
  "payroll.me.empty.title": "No payslips yet",
  "payroll.me.empty.body": "A month’s payslip appears here once payroll locks it.",
  "payroll.me.payDate": "Pay date {date}",
  "payroll.me.paidOn": "Paid {date}",
  "payroll.me.payslipTitle": "Payslip · {month}",
  "payroll.me.back": "My pay",
  "payroll.me.print": "Print",
  "payroll.me.notLocked.title": "This payslip isn’t ready",
  "payroll.me.notLocked.body": "A payslip appears once its month is locked.",
  "payroll.me.claims": "My expense claims",
  "payroll.me.claimsHint": "Send what you spent for work; approved claims are added to your next salary.",
  "payroll.me.claimsEmpty.title": "No claims yet",
  "payroll.me.claimsEmpty.body": "Bought something for work? Send a claim with its receipt.",
  "payroll.errors.hasBlockers": "Resolve the items under review before finalizing the month.",
  "payroll.errors.state": "That step doesn’t apply to the month as it stands. Reload to see where it is.",
  "payroll.errors.locked": "That month is locked. Record a correction for the next month instead.",
  "payroll.errors.monthConfirmation": "Type the month exactly as shown to lock it.",
  "payroll.errors.runNotFound": "We couldn’t find that payroll month.",
  "payroll.errors.payslipNotFound": "We couldn’t find that payslip.",
  "payroll.errors.adjustmentNotFound": "That entry no longer exists.",
  "payroll.errors.advanceNotFound": "That advance or installment can no longer change.",
  "payroll.errors.compensationInvalid": "A salary must be more than zero.",
  "payroll.errors.claimNotFound": "We couldn’t find that expense claim.",
  "payroll.errors.settlementNotDue": "Record the person’s last working day before settling their pay.",
  "payroll.errors.settlementNotFound": "There is no final settlement to remove.",
  "payroll.errors.employeeNotPaid": "That person has no HR record, so they aren’t on payroll.",
  "payroll.errors.periodLocked": "That month is locked.",
  "payroll.errors.conflict": "Someone else changed this meanwhile. Reload and try again.",
  "payroll.errors.receipt": "Attach a PDF, PNG, JPEG or WebP up to 10 MB."
}
